"use strict";
var Observable_1 = require("../../Observable");
var concatAll_1 = require("../../operator/concatAll");
Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
//# sourceMappingURL=concatAll.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/concatAll.js
 ** module id = 277
 ** module chunks = 1
 **/